import { render, staticRenderFns } from "./estandares.vue?vue&type=template&id=9fe8bfc2&"
import script from "./estandares.vue?vue&type=script&lang=js&"
export * from "./estandares.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports